<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="">
          <div class="header-form">
            <h5 v-if="formType == 'edit'">
              Editar {{ equipment }} {{ oldName }}
            </h5>
            <h5 v-else>Adicionar {{ equipment }}</h5>
          </div>

          <div class="pl-3 pr-3">
            <b-form-text id="nameInput">Nome *</b-form-text>
            <!-- <b-form-text v-show="form.NAME">Nome *</b-form-text> -->
            <b-form-input
              v-model="form.NAME"
              placeholder="Informe o nome"
              id="nameInput"
              maxlength="24"
              size="sm"
              aria-describedby="nameInput nameInputLiveFeedback"
              :state="nameState && notRepeatedName"
            />
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>

            <b-form-text id="input-maker">Fabricante *</b-form-text>
            <!-- <b-form-text v-show="form.MAKER">Fabricante *</b-form-text> -->
            <b-form-input
              v-model="form.MAKER"
              placeholder="Informe o fabricante"
              maxlength="24"
              id="input-maker"
              size="sm"
              aria-describedby="makerInputLiveFeedback"
              :state="makerState"
            />
            <b-form-invalid-feedback
              v-if="!makerState"
              id="makerInputLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>

            <b-form-text id="input-interface"> Interface * </b-form-text>
            <!-- <b-form-text id="posInput" v-if="form.INTERFACE != null">
              Interface *
            </b-form-text> -->
            <searchable-select
              v-model="form.INTERFACE"
              :options="sensorsInterfaces"
              text-field="NAME"
              value-field="NUM"
              :state="interfaceState"
              :clearable="false"
              placeholder="Selecione a interface"
            />
            <b-form-invalid-feedback
              v-if="!interfaceState"
              id="interfSelectLiveFeedback"
            >
              Campo obrigatório.
            </b-form-invalid-feedback>

            <b-form-text id="posInput"> Medições * </b-form-text>
            <!-- <b-form-text id="posInput"> Medições * </b-form-text> -->
            <b-form-select
              v-model="form.TOTAL_POS"
              aria-describedby="posInput posSelectLiveFeedback"
              :state="posState"
              id="posInput"
              size="sm"
            >
              <option v-for="n in 40" :key="n" :value="n">{{ n }}</option>
            </b-form-select>
            <b-form-invalid-feedback
              v-if="!posState"
              id="posSelectLiveFeedback"
            >
              Campo obrigatório.
            </b-form-invalid-feedback>
          </div>

          <div
            v-for="im in infoMeasurements"
            :key="im.POS"
            class="sensors-measures"
          >
            <div class="pl-3 pr-3 measures">
              <div class="group-inputs-title">Medições</div>
              <div>Medição {{ im.POS + 1 }}</div>
              <b-form-text id="typeInput" v-if="im.TYPE"> Tipo * </b-form-text>
              <searchable-select
                v-model="im.TYPE"
                :options="sensorsTypes"
                text-field="NAME"
                value-field="NUM"
                :state="im.TYPE != null"
                :clearable="false"
                placeholder="Tipo *"
              />
              <b-form-invalid-feedback
                v-if="!(im.TYPE != null)"
                id="typeSelectLiveFeedback"
              >
                Campo obrigatório.
              </b-form-invalid-feedback>
              <b-form-text id="unitInput" v-if="im.TYPE">
                Unidade *
              </b-form-text>
              <searchable-select
                v-model="im.UNIT"
                :options="sensorsUnits"
                text-field="NAME"
                value-field="NUM"
                :state="im.UNIT != null"
                :clearable="false"
                placeholder="Unidade *"
              />
              <b-form-invalid-feedback
                v-if="!(im.UNIT != null)"
                id="unitSelectLiveFeedback"
              >
                Campo obrigatório.
              </b-form-invalid-feedback>

              <div >Fórmula</div>
              <b-form-text v-if="!formulaValidate"
                >Há campos de fórmula inválidos.</b-form-text
              >
              <div class="row">
                <div class="col-xs-11">
                  <b-form-input v-model="im.VALUE_A" :formatter="coef" size="sm">
                  </b-form-input>
                </div>
                <div class="col-xs-1">
                  <b-form-input plaintext placeholder="x³" size="sm"> </b-form-input>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-11">
                  <b-form-input v-model="im.VALUE_B" :formatter="coef" size="sm">
                  </b-form-input>
                </div>
                <div class="col-xs-1">
                  <b-form-input plaintext placeholder="x²" size="sm"> </b-form-input>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-11">
                  <b-form-input v-model="im.VALUE_C" :formatter="coef" size="sm">
                  </b-form-input>
                </div>
                <div class="col-xs-1">
                  <b-form-input plaintext placeholder="x" size="sm"> </b-form-input>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-11">
                  <b-form-input v-model="im.VALUE_D" :formatter="coef" size="sm">
                  </b-form-input>
                </div>
                <div class="col-xs-1">
                  <b-form-input plaintext placeholder="" size="sm"> </b-form-input>
                </div>
              </div>
            </div>
          </div>
        </b-form>
      </div>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="closeModal"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2">
        <b-btn size="sm" variant="outline-secondary" @click="closeForm" class="mr-1 ml-2"> Fechar </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1 mr-2"> Salvar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import { notRepeatedName } from "@/pages/components/regist/form-functions";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";
export default {
  name: "sensor-form",
  components: {
    SearchableSelect,
  },
  props: {
    showForm: Boolean,
    equipment: String,
    oldName: String,
    formType: String,
    alreadyUsedNames: Array,
    sensorsInterfaces: Array,
    sensorsTypes: Array,
    sensorsUnits: Array,
    itemToEdit: [Number, Object],
  },
  data() {
    return {
      errors: [],
      form: {
        NAME: "",
        MAKER: "",
        INTERFACE: null,
        MEASURES: [],
        TOTAL_POS: 1,
      },
      infoMeasurements: [
        {
          TYPE: null,
          UNIT: null,
          POS: 0,
          VALUE_A: 0,
          VALUE_B: 0,
          VALUE_C: 1,
          VALUE_D: 0,
        },
      ],
      formulaValidate: true,
    };
  },
  watch: {
    "form.TOTAL_POS": function () {
      let im = this.infoMeasurements.map((i) => i);
      try {
        let new_len = this.form.TOTAL_POS;
        let cur_len = im.length;
        if (cur_len < new_len) {
          let diff = new_len - cur_len;
          for (let i = new_len - diff; i < new_len; i++) {
            im.push({
              TYPE: null,
              UNIT: null,
              POS: i,
              VALUE_A: 0,
              VALUE_B: 0,
              VALUE_C: 1,
              VALUE_D: 0,
            });
          }
        } else {
          let diff = cur_len - new_len;
          im.splice(new_len, diff);
        }
        this.infoMeasurements = im;
      } catch (e) {
        // console.log(e);
        console.log("Lista de opções de interface ainda não carregada");
      }
    },
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.loadForm();
        }
      }
    },
  },
  computed: {
    nameState() {
      return !!this.form.NAME;
    },
    makerState() {
      return !!this.form.MAKER;
    },
    posState() {
      return this.form.TOTAL_POS != null;
    },
    interfaceState() {
      return this.form.INTERFACE != null;
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
  },
  methods: {
    loadForm(){
      this.form.ID = this.itemToEdit.ID; //IMPORTANTE PARA DIFERENCIAR EDIÇÃO DE ADIÇÃO
      this.form.TOTAL_POS = this.itemToEdit.TOTAL_POS;
      this.form.NAME = this.itemToEdit.NAME;
      this.form.LAST_NAME = this.itemToEdit.NAME;
      this.form.MAKER = this.itemToEdit.MAKER;
      this.form.INTERFACE = this.itemToEdit.INTERFACE;
      this.getFormulaValues();
    },
    closeModal(){
      this.$refs.formError.hide()
      this.formulaValidate = true
    },
    closeForm(){
      this.resetForm()
      this.$emit("close-form");
    },
    coef(value) {
      let regex = /^[-+.0-9]*$/;
      if (value) {
        if (regex.test(value)) return value;
      }
      return "";
    },
    checkSignal(value) {
      let result = "";
      if (value[0] != "-" && value[0] != "+") result = "+" + value;
      else result = value;
      return result;
    },
    getFormula() {
      let len = this.infoMeasurements.length;
      for (let i = 0; i < len; i++) {
        let result = [];
        if (
          isNaN(this.infoMeasurements[i].VALUE_A) ||
          isNaN(this.infoMeasurements[i].VALUE_B) ||
          isNaN(this.infoMeasurements[i].VALUE_C) ||
          isNaN(this.infoMeasurements[i].VALUE_D)
        ) {
          this.formulaValidate = false;
        }
        result.push(this.checkSignal(this.infoMeasurements[i].VALUE_A));
        result.push(this.checkSignal(this.infoMeasurements[i].VALUE_B));
        result.push(this.checkSignal(this.infoMeasurements[i].VALUE_C));
        result.push(this.checkSignal(this.infoMeasurements[i].VALUE_D));
        while (result[0] == 0 || result[0] == "") {
          result.shift();
        }
        result = result.join();
        this.infoMeasurements[i].FORMULA = result;
      }
      this.form.MEASURES = this.infoMeasurements;
      return this.formulaValidate;
    },
    getFormulaValues() {
      let im = [];
      let len = this.itemToEdit.MEASURES.length;
      for (let i = 0; i < len; i++) {
        let formula = this.itemToEdit.MEASURES[i].FORMULA.split(",");
        let flen = formula.length;
        let values = [0, 0, 0, 0];
        for (let v = 0; v < flen; v++) {
          values[v] = formula[flen - 1 - v];
        }
        im.push({
          TYPE: this.itemToEdit.MEASURES[i].TYPE,
          UNIT: this.itemToEdit.MEASURES[i].UNIT,
          POS: i,
          VALUE_A: values[3],
          VALUE_B: values[2],
          VALUE_C: values[1],
          VALUE_D: values[0],
        });
      }
      this.infoMeasurements = im;
    },
    resetForm() {
      this.infoMeasurements = [
        {
          TYPE: null,
          UNIT: null,
          POS: 0,
          VALUE_A: 0,
          VALUE_B: 0,
          VALUE_C: 1,
          VALUE_D: 0,
        },
      ];
      this.form = {
        NAME: "",
        MAKER: "",
        INTERFACE: null,
        MEASURES: [],
        TOTAL_POS: 1,
      };

      this.formulaValidate = true
    },
    checkMeasuresDetails() {
      let len = this.infoMeasurements.length;
      let count = 0;
      for (let i = 0; i < len; i++) {
        if (
          this.infoMeasurements[i].TYPE != null &&
          this.infoMeasurements[i].UNIT != null
        )
          count++;
      }
      if (count < len) return false;
      else return true;
    },
    checkForm() {
      this.errors = [];
      let states = [
        this.nameState,
        this.notRepeatedName,
        this.makerState,
        this.interfaceState,
        this.posState,
        this.checkMeasuresDetails(),
        this.getFormula(),
      ];
      let erros = [
        "Nome é obrigatório.",
        "Nome escolhido já está em uso. Verifique.",
        "Fabricante é obrigatório.",
        "É necessário especificar a interface do modelo de sensor.",
        "É necessário especificar a quantidade de medições que o modelo de sensor tem.",
        "Existem valores inválidos para o tipo e unidade das medições. Ambas informações são obrigatórias para cada medição.",
        "Há campos de fórmula inválidos.",
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.$emit("submit", this.form);
        this.$emit("close-form");
      }
    },
  },
};
</script>

<style scoped>

.error {
  color: #dc3545;
}
.measures > div + div{
  font-size: 0.8em;
}
#form{
  padding-left: 0;
  padding-right: 0;
}
@media screen and (max-width: 768px) {
  .container-form{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0.5em;
    margin-right: 0;
  }

}
</style>
